import { useState } from 'react';
import { toast } from 'react-toastify';
import useApi from '../useApis';

const useSMSPackage = () => {
  const [smsPackages, setSMSPackages] = useState([]);
  const [smsPackageSubscription, setSmsPackageSubscription] = useState([]);
  const [loading, setLoading] = useState(false);
  const api = useApi();
  const getAllSMSPackages = async (params, onCancel) => {
    const response = await api?.getAllSMSPackages(params);
    if (response?.data?.headers?.code === 200) {
      setSMSPackages(response?.data?.body?.packages?.row);
      if (typeof onCancel === 'function') onCancel();
    } else {
      toast.error(response?.data?.headers?.msg, 'error');
    }
  };
  

  const getSmsSubscription = async (params, onCancel) => {
    const { filter, ...rest } = params;

    const response = await api?.getSmsSubscription(rest, filter);
    if (response?.data?.headers?.code === 200) {
      setSmsPackageSubscription(response?.data?.body);
      if (typeof onCancel === 'function') onCancel();
    } else {
      toast.error(response?.data?.headers?.msg, 'error');
    }
  };

  const addSmsSubscription = async (params, onCancel) => {
    setLoading(true);
    const response = await api?.addSmsSubscription(params);
    if (response?.data?.headers?.code === 200) {

      getSmsSubscription({
        pageNumber: 1,
        pageSize: 10,
        totalRowsCount: 0,
        sortField: '',
        sortDirection: '',
        search: '',
        filter: null
      });
      toast.success('Package subscribed successfully');
      if (typeof onCancel === 'function') onCancel();
    } else {
      toast.error(response?.data?.headers?.msg, 'error');
    }
    setLoading(false);
  };
  const deleteSmsSubscription = async (params, onCancel) => {
    setLoading(true);
    const response = await api?.deleteSmsSubscription(params);
    if (response?.data?.headers?.code === 200) {
      getSmsSubscription({
        pageNumber: 1,
        pageSize: 10,
        totalRowsCount: 0,
        sortField: '',
        sortDirection: '',
        search: '',
        filter: null
      });
      toast.success('Request cancel successfully');
      if (typeof onCancel === 'function') onCancel();
    } else {
      toast.error(response?.data?.headers?.msg, 'error');
    }
    setLoading(false);
  };
  return {
    loading,
    smsPackages,
    getAllSMSPackages,
    getSmsSubscription,
    addSmsSubscription,
    smsPackageSubscription,
    deleteSmsSubscription
  };
};

export default useSMSPackage;
